/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { cn } from '@/lib/utils';

export type BazaarvoiceShow = 'rating_summary' | 'reviews' | 'questions' | 'inline_rating' | 'review_highlights';

type BazaarvoiceContainerProps = {
    show: BazaarvoiceShow;
    productId: string;
    seoHtml?: string;
    redirectUrl?: string;
    seo?: boolean;
    className?: string;
};

/**
 * Hosted Conversations container. BV's scout script (`bv.js`) hydrates these nodes.
 */
export function BazaarvoiceContainer({
    show,
    productId,
    seoHtml,
    redirectUrl,
    seo = true,
    className,
}: BazaarvoiceContainerProps) {
    if (!productId) {
        return null;
    }

    return (
        <div
            className={cn(className)}
            data-bv-show={show}
            data-bv-product-id={productId}
            data-bv-productid={productId}
            data-bv-seo={seo ? undefined : 'false'}
            data-bv-redirect-url={redirectUrl}
            // eslint-disable-next-line react/no-danger -- Bazaarvoice SEO markup is server-fetched HTML
            dangerouslySetInnerHTML={seoHtml ? { __html: seoHtml } : undefined}
        />
    );
}
